export default __webpack_public_path__ + "static/media/Logout.094d200c.svg";